module.exports = "/assets/data/9d27185b06d81af71b83dac46ee69184-B26.data.json";